import { FC } from "react";
import { InformesRouter } from "./InformesRouter";

export const InformesWrapper: FC = () => {
    return (
        <>
            <InformesRouter />
        </>
    )
}